<template>
  <div class="exam-properties-menu" :id="menuId" :uk-offcanvas="'flip: true; bg-close: false; show: true'">
    <div class="uk-offcanvas-bar">
      <button :uk-close="true" class="uk-offcanvas-close" type="button"/>
      <h4><i class="uil-cog"/> {{$t('exam.exam_features')}} </h4>
      <hr/>

      <div class="row" >
        <div class="col-xl-12 m-auto">
          <div class="form-group row mb-2">
            <label class="col-form-label" for="exam_title">
              {{ $t("exam.name") }}<span class="required">*</span>
            </label>
            <input id="exam_title" v-model="examData.exam_name" :placeholder="$t('exam.enter_name')"
                   class="form-control mb-2" type="text"/>
          </div>

          <div class="form-group row mb-2" v-if="false">
            <label class="col-md-8 col-form-label p-0">
              {{ $t('general.has_exam_pass_grade') }}
            </label>
            <div class="col-md-4">
              <div class="d-flex justify-content-end  align-items-center">
                <toggle-button v-model="examData.has_exam_pass_grade" :sync="true" color="#ae71ff"/>
              </div>
            </div>
          </div>

          <!-- Gecme notu YALNIZCA sinirsiz hakli sinavlarda anlamli. Sinirli
               hakta backend passmark'i 0 kaydediyor (0 puan dahil her sonuc
               basarili sayilir ve bir hak tuketir), o yuzden alan 0'a sabitlenip
               kilitleniyor — admin girdigi degerin korunacagini sanmasin. -->
          <!-- Sinirli hakta alttaki bilgi notu bosluğu sagliyor; sinirsizda not
               gizlendigi icin margin'i form-group'un kendisi vermeli. -->
          <div :class="isUnlimitedAttempt ? 'mb-2' : 'mb-0'" class="form-group row">
            <label class="col-form-label col-md-8 pl-0" for="passmark">
              {{ $t("exam.passmark") }} (0-100)<span class="required">*</span>
            </label>
            <input id="passmark" v-model="examData.passmark" :disabled="!isUnlimitedAttempt"
                   :placeholder="$t('exam.enter_passmark')"
                   class="form-control col-md-4 mb-0" max="100" min="0" type="number"/>
            <span v-if="!isUnlimitedAttempt" class="text-muted mb-2"><i class="uil-info-circle"/> <i>{{
                $t('general.limited_attempt_passmark_info')
              }}</i></span>
          </div>

          <div class="form-group row mb-2" v-if="false">
            <label class="col-form-label col-md-8 pl-0">
              {{ $t('general.if_failed_from_exam') }}
            </label>
            <select v-model="examData.if_failed_from_exam" class="selectpicker2 form-control col-md-4 mb-0">
              <option selected value="retry">{{ $t('general.retry_exam') }}</option>
              <option value="report">{{ $t('general.reflect_to_exam_report') }}</option>
            </select>
          </div>

          <div class="form-group row mb-2">
            <label class="col-form-label col-md-8 pl-0">
              {{ $t("exam.duration") }}<span class="required">*</span>
            </label>
            <input id="duration" v-model="examData.duration" :placeholder="$t('exam.enter_duration')"
                   class="form-control col-md-4 mb-0" type="number"/>
          </div>

          <!-- Sinav hakki. Hak, kullanici sinavi tamamlayip sonuc kaydedildiginde
               tukenir; sinavi acmak hak tuketmez. Basarili ve basarisiz sonuclarin
               ikisi de bir hak tuketir. `attempt_limit === null` sinirsiz demek
               (atama suresiyle sinirli); ayri bir "hak turu" alani gonderilmez. -->
          <div class="form-group row mb-0">
            <label class="col-md-9 col-form-label p-0">
              {{ $t('general.unlimited_attempt') }}
            </label>
            <div class="col-md-3">
              <div class="d-flex justify-content-end align-items-center">
                <toggle-button v-model="isUnlimitedAttempt" :sync="true" color="#ae71ff"/>
              </div>
            </div>
            <span class="text-muted mb-2"><i class="uil-info-circle"/> <i>{{
                $t('general.unlimited_attempt_means')
              }}</i></span>
          </div>

          <div class="form-group row mb-2" v-if="!isUnlimitedAttempt">
            <label class="col-form-label col-md-8 pl-0" for="attempt_limit">
              {{ $t('general.attempt_limit') }}<span class="required">*</span>
            </label>
            <input id="attempt_limit" v-model="examData.attempt_limit"
                   :placeholder="$t('general.enter_attempt_limit')"
                   class="form-control col-md-4 mb-0" min="1" step="1" type="number"/>
          </div>

          <div class="form-group row mb-3" v-if="false">
            <label class="col-form-label col-md-8 pl-0">
              {{ $t('general.if_exit_from_exam') }}
            </label>
            <select v-model="examData.if_exit_from_exam" class="selectpicker2 form-control col-md-4 mb-0">
              <option selected value="continue">{{ $t('general.continue_from_where_left') }}</option>
              <option value="done">{{ $t('general.exam_will_be_completed') }}</option>
            </select>
          </div>

          <div class="form-group row mb-0" v-if="false">
            <label class="col-md-9 col-form-label p-0">
              {{ $t('general.every_question_has_time_limit') }}
            </label>
            <div class="col-md-3">
              <div class="d-flex justify-content-end align-items-center">
                <toggle-button v-model="examData.every_question_has_time_limit" :sync="true" color="#ae71ff"/>
              </div>
            </div>
            <span class="text-muted mb-3"><i class="uil-info-circle"/> <i>{{ $t('general.add_durations_from_question_area') }}</i></span>
          </div>

          <div class="form-group row mb-0" v-if="false">
            <label class="col-md-9 col-form-label p-0">
              {{ $t('general.every_question_has_score') }}
            </label>
            <div class="col-md-3">
              <div class="d-flex justify-content-end align-items-center">
                <toggle-button v-model="examData.every_question_has_score" :sync="true" color="#ae71ff"/>
              </div>
            </div>
            <span class="text-muted mb-3"><i class="uil-info-circle"/> <i>{{ $t('general.add_scores_from_question_area') }}</i></span>
          </div>

          <div class="form-group row mb-0">
            <label class="col-md-9 col-form-label p-0">
              {{ $t("exam.is_mix_questions") }}
            </label>
            <div class="col-md-3">
              <div class="d-flex justify-content-end align-items-center">
                <toggle-button v-model="examData.is_mix_questions" :sync="true" color="#ae71ff"/>
              </div>
            </div>
          </div>

          <div class="form-group row mb-0">
            <label class="col-md-9 col-form-label p-0">
              {{ $t("exam.is_mix_answers") }}
            </label>
            <div class="col-md-3">
              <div class="d-flex justify-content-end align-items-center">
                <toggle-button v-model="examData.is_mix_answers" :sync="true" color="#ae71ff"/>
              </div>
            </div>
          </div>

          <div class="form-group row mb-0">
            <label class="col-md-9 col-form-label p-0">
              {{ $t("exam.show_right_answers") }}
            </label>
            <div class="col-md-3">
              <div class="d-flex justify-content-end align-items-center">
                <toggle-button v-model="examData.show_right_answers" :sync="true" color="#ae71ff"/>
              </div>
            </div>
          </div>

          <div class="form-group row mb-0">
            <label class="col-md-9 col-form-label p-0">
              {{ $t("exam.show_user_answers") }}
            </label>
            <div class="col-md-3">
              <div class="d-flex justify-content-end align-items-center">
                <toggle-button v-model="examData.show_user_answers" :sync="true" color="#ae71ff"/>
              </div>
            </div>
          </div>

          <div class="form-group row mb-0">
            <label class="col-md-9 col-form-label p-0">
              {{ $t("exam.show_result") }}
            </label>
            <div class="col-md-3">
              <div class="d-flex justify-content-end  align-items-center">
                <toggle-button v-model="examData.show_result" :sync="true" color="#ae71ff"/>
              </div>
            </div>
          </div>

          <div class="form-group row mb-0">
            <label class="col-md-9 col-form-label p-0">
              {{ $t("exam.is_compulsory") }}
            </label>
            <div class="col-md-3">
              <div class="d-flex justify-content-end  align-items-center">
                <toggle-button v-model="examData.is_compulsory" :sync="true" color="#ae71ff"/>
              </div>
            </div>
          </div>

          <div class="form-group row mb-0" v-if="false">
            <label class="col-md-9 col-form-label p-0">
              {{ $t('general.exam_can_be_duplicated') }}
            </label>
            <div class="col-md-3">
              <div class="d-flex justify-content-end  align-items-center">
                <toggle-button  :sync="true" color="#ae71ff"/>
              </div>
            </div>
          </div>

          <div class="form-group row mb-0">
            <label class="col-md-9 col-form-label p-0">
              {{ $t('general.pre_post') }}
            </label>
            <div class="col-md-3">
              <div class="d-flex justify-content-end  align-items-center">
                <toggle-button v-model="examData.pre_post"  :sync="true" color="#ae71ff" :disabled="isPrePostActive" />
              </div>
            </div>

            <span>{{$t('general.pre_post_means')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExamPropertiesMenu',
  props: {
    menuId: {
      type: String,
      default: 'exam-properties'
    },
    initialData: {
      type: Object,
      default: () => {}
    },
    isPrePostActive:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      // api den değişkenleri kontrol et
      examData: {
        exam_name: '',
        passmark: 50, //max: 100
        if_failed_from_exam: 'retry',
        if_exit_from_exam:'continue',
        duration: 20,
        show_right_answers: true,
        show_user_answers: true,
        is_mix_questions: true,
        is_mix_answers: true,
        show_result: true,
        is_compulsory: true,
        has_exam_pass_grade:false,
        every_question_has_time_limit:false,
        every_question_has_score:false,
        pre_post:false,
        // null = sinirsiz; ekleme ekraninda VARSAYILAN bu. Backend'in "alan
        // gonderilmezse 1" varsayilani devreye girmiyor, alani her zaman
        // gonderiyoruz.
        attempt_limit: null,
      },
      // "Sinirsiz" acilip kapatildiginda kullanicinin yazdigi sayiyi geri
      // getirebilmek icin tutuluyor; payload'a GIRMEZ.
      attemptLimitDraft: 1,
      // Ayni sekilde: sinirli hakka gecildiginde passmark 0'a sabitlenir,
      // sinirsiza donulunce admin'in girdigi deger geri gelir.
      passmarkDraft: 50,
    }
  },
  computed: {
    isUnlimitedAttempt: {
      get() {
        return this.examData.attempt_limit === null;
      },
      set(value) {
        if (!value) {
          // Sinirli hak -> gecme notu uygulanmaz, backend passmark'i 0 kaydeder
          this.rememberPassmark();
          this.examData.attempt_limit = this.attemptLimitDraft;
          this.examData.passmark = 0;
          return;
        }
        const current = Number(this.examData.attempt_limit);
        if (Number.isInteger(current) && current > 0) {
          this.attemptLimitDraft = current;
        }
        this.examData.attempt_limit = null;
        this.examData.passmark = this.passmarkDraft;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeData()
      UIkit.offcanvas(`#${this.menuId}`).show();
      this.createRandomExamName()
    });
  },

  methods: {
    initializeData() {
      if (this.initialData && Object.keys(this.initialData).length) {
        this.applyExamData(this.initialData)
      }
    },

    /**
     * `attempt_limit`i bu komponenti kullanan eski sayfalar (Add-demo /
     * Edit-demo) hic gondermiyor. Anahtar eksik kalirsa Vue reaktivitesi
     * kurulmaz ve "Sinirsiz" anahtari calismaz; o yuzden her atamada
     * normalize ediliyor. Diger anahtarlarin davranisi degismiyor.
     */
    applyExamData(source) {
      const attemptLimit = this.normalizeAttemptLimit(source.attempt_limit);

      this.rememberPassmark(source.passmark);

      this.examData = {
        ...source,
        attempt_limit: attemptLimit,
        // Sinirli hakta backend passmark'i 0 kaydediyor. Eski kayitlarda
        // (0 olmayan passmark + sinirli hak) ekranda 0 gostermek SART:
        // guncellemede backend zaten 0 yazacak, admin degerinin korunacagini
        // sanmasin.
        passmark: attemptLimit === null ? source.passmark : 0,
      };
    },

    /** "Sinirsiz"a geri donulurse admin'in girdigi gecme notunu geri getir. */
    rememberPassmark(value = this.examData.passmark) {
      const parsed = Number(value);
      if (Number.isFinite(parsed) && parsed > 0 && parsed <= 100) {
        this.passmarkDraft = parsed;
      }
    },

    /** null -> sinirsiz; gecersiz deger -> en az olan 1. */
    normalizeAttemptLimit(value) {
      if (value === null || value === undefined) return null;
      const parsed = Number(value);
      return Number.isInteger(parsed) && parsed > 0 ? parsed : 1;
    },

    createRandomExamName() {
      this.examData.exam_name= this.examData.exam_name || `${this.$t('exam.exam')}-` + (Math.floor(Math.random() * 1000) + 1);
    },

    handleNewExamMenu() {
      // refs for parent component
      return this.examData;
    },

  },
  watch: {
    initialData: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length) {
          this.applyExamData(newVal);
        }
      },
      deep: true,
      immediate: true
    }
  },

}
</script>
<!--add uk-offcanvas-container to actived scroll on main parent componnet scrollToTop , do not delete the ->.uk-offcanvas-page, .uk-offcanvas-container -->

<style >
.uk-offcanvas-page, .uk-offcanvas-container {
  overflow-x: initial !important;
}
.disable-exam-properties-menu {
  pointer-events: none;  /* Kullanıcının tıklamalarını engeller */
  opacity: 0.5;
}
</style>
